import { render, staticRenderFns } from "./popup-modal.vue?vue&type=template&id=94a7e852"
import script from "./popup-modal.vue?vue&type=script&lang=js"
export * from "./popup-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports